export default "__VITE_ASSET__BSSF2XBZ__"